export const comments_3389023 = {"data":{"data":[],"links":{}}}